import React, { useState, useEffect } from 'react';
import { setSEO } from '../lib/seo';

const C = { navy:'#001f3a', navyMid:'#0b3558', navyDark:'#0d1f30', orange:'#f07820', orangeDk:'#9a4600', light:'#f8f9ff', white:'#ffffff' };

const LOGO_W  = `${process.env.PUBLIC_URL}/LogoBlanco.png`;
const BEREADY = `${process.env.PUBLIC_URL}/BeReady.jpg`;
const BEREADY_PDF_LINK = 'https://drive.google.com/file/d/1HqJvYn1l4h4H47HR7L3gSrS20ben6w_w/view?usp=sharing';

export default function WebBeReady() {
  const [form, setForm]     = useState({ nombre:'', email:'', pais:'' });
  const [status, setStatus] = useState('idle');
  const [error, setError]   = useState('');

  useEffect(() => {
    setSEO({
      title: 'BeReady | Guía Gratuita de Empleabilidad Remota - HireMeUp',
      description: 'Descarga gratis BeReady, la guía base de la metodología HireMeUp. Prepara tu perfil, mentalidad y estrategia para conseguir trabajo remoto internacional desde LATAM.',
      canonical: 'https://hiremeupglobal.com/beready',
    });
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.nombre || !form.email || !form.pais) { setError('Completa todos los campos.'); return; }
    setStatus('loading'); setError('');
    try {
      const res  = await fetch('https://api.web3forms.com/submit', {
        method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body: JSON.stringify({
          access_key: 'd8629bd2-661c-40b3-ac0d-182e51fee127',
          name: form.nombre, email: form.email, pais: form.pais,
          subject: `Nueva descarga BeReady - ${form.nombre}`,
          message: `${form.nombre} (${form.pais}) descargó BeReady.`,
          from_name: 'HireMeUp',
          replyto: form.email,
          autoresponse: 'true',
          autoresponse_subject: '¡Tu BeReady está listo!',
          autoresponse_message: `Hola ${form.nombre},\n\nGracias por unirte a HireMeUp. Aquí tienes tu guía BeReady:\n\n${BEREADY_PDF_LINK}\n\nEste es tu punto de partida. Léelo con calma y aplica cada ejercicio.\n\nCualquier duda escríbenos a mathius@hiremeupglobal.com\n\nEl equipo HireMeUp`,
        }),
      });
      const data = await res.json();
      if (data.success) setStatus('success');
      else { setStatus('error'); setError('Hubo un error. Intenta de nuevo.'); }
    } catch { setStatus('error'); setError('Error de conexión. Intenta de nuevo.'); }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@700;800;900&family=Inter:wght@400;500;600&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        body{font-family:'Inter',sans-serif;background:${C.light}}
        .d{font-family:'Manrope',sans-serif} a{text-decoration:none}
        .bo{background:linear-gradient(135deg,${C.orange},${C.orangeDk});color:white;border:none;cursor:pointer;font-family:'Inter',sans-serif;font-weight:700;transition:opacity .18s}
        .bo:hover{opacity:.9}
        .field{width:100%;padding:11px 14px;border-radius:8px;border:1.5px solid rgba(0,31,58,.12);font-size:14px;outline:none;color:${C.navy};background:white;font-family:'Inter',sans-serif}
        .field:focus{border-color:${C.orange}}
        @media(max-width:768px){.br-grid{flex-direction:column!important}.br-pad{padding:40px 20px!important}}
      `}</style>

      {/* Navbar */}
      <nav style={{ background:C.navyDark, padding:'0 40px', height:'56px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <a href="/"><img src={LOGO_W} alt="HireMeUp" style={{ height:'45px', objectFit:'contain' }} /></a>
        <a href="https://app.hiremeupglobal.com" style={{ display:'inline-flex', alignItems:'center', gap:'6px', padding:'7px 14px', borderRadius:'8px', background:`linear-gradient(135deg,${C.orange},${C.orangeDk})`, color:'white', fontSize:'13px', fontWeight:700 }}>Ir a la app →</a>
      </nav>

      {/* Contenido: fondo claro */}
      <section className="br-pad" style={{ minHeight:'calc(100vh - 56px)', background:C.light, display:'flex', alignItems:'center', padding:'60px 40px' }}>
        <div className="br-grid" style={{ maxWidth:'960px', margin:'0 auto', width:'100%', display:'flex', gap:'64px', alignItems:'center' }}>

          {/* Left: info */}
          <div style={{ flex:1, minWidth:'260px' }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:'8px', background:`${C.orange}12`, border:`1px solid ${C.orange}30`, borderRadius:'20px', padding:'5px 14px', marginBottom:'24px' }}>
              <div style={{ width:'6px', height:'6px', borderRadius:'50%', background:C.orange }} />
              <span style={{ fontSize:'11px', fontWeight:700, color:C.orange, letterSpacing:'.1em', textTransform:'uppercase' }}>Descarga gratuita</span>
            </div>
            <div style={{ width:'80px', height:'108px', borderRadius:'10px', overflow:'hidden', marginBottom:'24px', boxShadow:'0 12px 32px rgba(0,31,58,.12)' }}>
              <img src={BEREADY} alt="BeReady" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            </div>
            <h1 className="d" style={{ fontSize:'clamp(2rem,4vw,3rem)', fontWeight:900, letterSpacing:'-.03em', lineHeight:1.1, marginBottom:'20px' }}>
              <span style={{ color:C.navy, display:'block' }}>BeReady:</span>
              <span style={{ color:C.orange, display:'block' }}>Tu punto de partida.</span>
            </h1>
            <p style={{ fontSize:'15px', lineHeight:1.7, color:'rgba(0,31,58,.6)', marginBottom:'24px', maxWidth:'420px' }}>
              La guía base de la metodología HireMeUp. Prepara tu perfil, mentalidad y estrategia para comenzar tu búsqueda remota con intención y dirección real.
            </p>
            {['Estrategia para postular con dirección','Cómo posicionarte en el mercado remoto','Errores que debes evitar desde el día uno','Ejercicios prácticos para empezar hoy'].map((f,i) => (
              <div key={i} style={{ display:'flex', gap:'10px', marginBottom:'8px' }}>
                <span style={{ color:C.orange, fontSize:'14px', flexShrink:0 }}>✓</span>
                <span style={{ fontSize:'14px', color:'rgba(0,31,58,.65)' }}>{f}</span>
              </div>
            ))}
          </div>

          {/* Right: form con card elevada */}
          <div style={{ flex:'0 0 380px', minWidth:'280px', width:'100%' }}>
            <div style={{ background:C.white, borderRadius:'20px', padding:'36px 32px', boxShadow:'0 16px 48px rgba(0,31,58,.08)', border:'1px solid rgba(0,31,58,.06)' }}>
              {status === 'success' ? (
                <div style={{ textAlign:'center', padding:'20px 0' }}>
                  <div style={{ width:'64px', height:'64px', borderRadius:'50%', background:'rgba(15,118,110,.1)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                    <span style={{ fontSize:'28px', color:'#0f766e' }}>✓</span>
                  </div>
                  <h3 className="d" style={{ fontSize:'20px', fontWeight:800, color:C.navy, marginBottom:'8px' }}>Gracias por unirte a HireMeUp:</h3>
                  <p style={{ fontSize:'14px', color:'rgba(0,31,58,.55)', lineHeight:1.6, marginBottom:'16px' }}>
                    Aquí tienes tu guía BeReady 👇.
                  </p>
                  <a href={BEREADY_PDF_LINK} target="_blank" rel="noopener noreferrer" className="bo"
                    style={{ display:'inline-block', padding:'11px 24px', borderRadius:'10px', fontSize:'14px', marginBottom:'16px' }}>
                    Descargar ahora →
                  </a>
                  <br />
                  <a href="/" style={{ fontSize:'13px', color:C.orange, fontWeight:600 }}>← Volver al inicio</a>
                </div>
              ) : (
                <>
                  <h2 className="d" style={{ fontSize:'20px', fontWeight:800, color:C.navy, marginBottom:'6px' }}>Descarga BeReady gratis</h2>
                  <p style={{ fontSize:'13px', color:'rgba(0,31,58,.45)', marginBottom:'24px' }}>Completa el formulario y recíbelo en tu correo al instante.</p>
                  <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
                    <div>
                      <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>Nombre completo</label>
                      <input type="text" value={form.nombre} onChange={e => setForm({...form, nombre:e.target.value})} placeholder="Tu nombre" className="field" />
                    </div>
                    <div>
                      <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>Correo electrónico</label>
                      <input type="email" value={form.email} onChange={e => setForm({...form, email:e.target.value})} placeholder="tu@email.com" className="field" />
                    </div>
                    <div>
                      <label style={{ fontSize:'12px', fontWeight:600, color:'rgba(0,31,58,.6)', display:'block', marginBottom:'6px' }}>País</label>
                      <select value={form.pais} onChange={e => setForm({...form, pais:e.target.value})} className="field">
                        <option value="">Selecciona tu país</option>
                        {['México','Colombia','Argentina','Chile','Perú','Ecuador','Venezuela','Bolivia','Paraguay','Uruguay','Guatemala','Honduras','El Salvador','Costa Rica','Panamá','España','Otro'].map(p => <option key={p} value={p}>{p}</option>)}
                      </select>
                    </div>
                    {error && <p style={{ fontSize:'12px', color:'#dc2626', background:'#fef2f2', padding:'8px 12px', borderRadius:'6px' }}>{error}</p>}
                    <button type="submit" disabled={status==='loading'} className="bo"
                      style={{ padding:'13px', borderRadius:'10px', fontSize:'14px', marginTop:'4px', opacity:status==='loading'?.7:1, width:'100%' }}>
                      {status==='loading'?'Enviando...':'Quiero mi BeReady gratis →'}
                    </button>
                    <p style={{ fontSize:'11px', color:'rgba(0,31,58,.3)', textAlign:'center' }}>Sin spam. Solo valor real.</p>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
